<p>create-jeu-quatre-img works!</p>
